// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Go3nK","footer":"styles_footer__zAfPK"};